import React, {FC, PropsWithChildren, useEffect} from 'react';

import {cn} from '@bem-react/classname';
import * as Metrika from 'ui/utils/metrika';

import Footer from '../Footer';
import Header from '../Header';
import IframeLayout from '../IframeLayout';
import PreviewLayout from '../PreviewLayout';

import './Layout.scss';

const {iframe, preview} = window.YC;
const cnLayout = cn('Layout');

const Layout: FC<PropsWithChildren<{}>> = ({children}) => {
    useEffect(() => {
        Metrika.common();
    }, []);

    if (iframe) {
        return <IframeLayout>{children}</IframeLayout>;
    }
    if (preview) {
        return <PreviewLayout>{children}</PreviewLayout>;
    }
    return (
        <div className={cnLayout()}>
            <Header />
            <main className={cnLayout('Content')}>{children}</main>
            <Footer />
        </div>
    );
};
export default Layout;
